import { render, staticRenderFns } from "./TitularidadeIngressoForm.vue?vue&type=template&id=4260e2f4&scoped=true"
import script from "./TitularidadeIngressoForm.vue?vue&type=script&lang=js"
export * from "./TitularidadeIngressoForm.vue?vue&type=script&lang=js"
import style0 from "./TitularidadeIngressoForm.vue?vue&type=style&index=0&id=4260e2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4260e2f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VTextField})
